import { useCallback } from 'react';

import { inIframe, sendToParent } from '@lyearn/core/utils/iframe';
import useAnalytics from '@/components/Analytics/hooks/useAnalytics';
import { useAppConfig } from '@/hooks/useAppConfig';
import useNavigation from '@/hooks/useNavigation';
import { defaultRoute } from '@/pages/corporate/routes/admin';
import { useRoleBasedNavigation } from '@/pages/corporate/routes/hooks/useAdminRoutes';

export default function useGoToHome() {
  const navigation = useNavigation();
  const { track } = useAnalytics();
  const rootRoute = useRoleBasedNavigation(defaultRoute());
  const { ui } = useAppConfig();

  const onBackToHome = useCallback(
    (source?: string) => {
      if (inIframe() && !ui.isIFrameBackAllowed) {
        return sendToParent(JSON.stringify({ action: 'BackToHomePressed', source: source }));
      }

      navigation.push(rootRoute, {
        appendQuery: false,
      });
      track('Course Back To Home button Clicked');
    },
    [navigation, rootRoute, track, ui.isIFrameBackAllowed],
  );

  return {
    onBackToHome,
  };
}
